import { createEffect, createEvent, createStore } from "effector"
import { IItem } from "../types/Item"
import { API } from "../API"
import { ICollection } from "../types/collection"

export const getCollectionItems = createEffect(async(collectionId:string)=>{
    const res = await API.getCollections(collectionId)
    
    return res
})

export const clearCollectionItems = createEvent()
export const $collectionItems = createStore<IItem[]>([])
.on(getCollectionItems.doneData,(state,res)=> [...state,...res.toys])
.on(clearCollectionItems,()=>[])


export const getCollections = createEffect(async () => {
    const res = await API.getCollections();

    return res;
})

export const clearCollections = createEvent();
export const $collections = createStore<ICollection[]>([])
.on(getCollections.doneData,(state,res)=> [...state,...res])
.on(clearCollections,()=>[])